import React, { useState,useRef ,useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import ElectricityComponent from '../components/Electricity';
import GasComponent from '../components/Gas';
import { DownOutlined } from '@ant-design/icons';
import {Button,Dropdown,Form,Input,InputNumber,Row,Select,DatePicker,Space, notification,Flex} from 'antd';
import { surveyLeadSave, masterSource} from '../service/UserDetails';
import {loginUserId} from "../service/UserDetails";
import Item from 'antd/es/list/Item';
import moment  from 'moment';
import axios from "axios";
import { Divider } from 'antd';
import { Checkbox } from 'antd';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);


const RegistrationFormAdmin = (props) => {
  const [isNew, setIsNew] = useState(true);
  const location = useLocation();
  const {state={}} = location || {};
  const {token="", user={},findUser={}, isEdit} = state || {};  
  const ref1 = useRef(); 
  const ref2 =  useRef();
  const [form] = Form.useForm();  
  const [dropdownValue, setdropdownValue] = useState('');
  const { Option } = Select;
  const [initialFormValues, setInitialFormValues] = useState({});
  const [metertypeOption , setMeterTypeOption] = useState([]);
  const [productSupplierOptions , setProductSupplierOptions] = useState([]);
  const [salesOptionsListDropdown , setSalesOptionList] = useState([]);
  const LIVE_BASE = process.env.REACT_APP_API_LIVE_URL;

 
  const setInitialValues =(findUser)=>{
    //call api get data and set in  initialValues
    //setInitialFormValues(apiData);
    
     setInitialFormValues(findUser);
     
     form.setFieldValue("agent_id",findUser.id);
     form.setFieldValue("business_name",findUser.attributes.business_name);
form.setFieldValue("customer_name",findUser.attributes.customer_name);
form.setFieldValue("billing_address",findUser.attributes.billing_address);
form.setFieldValue("billing_postcode",findUser.attributes.billing_postcode);
form.setFieldValue("contact_number",findUser.attributes.contact_number);
form.setFieldValue("email_address",findUser.attributes.email_address);

form.setFieldValue("elec_billing_name",findUser.attributes.electricity.billing_name);
form.setFieldValue("elec_supply_address",findUser.attributes.electricity.supply_address);
form.setFieldValue("elec_supply_postcode",findUser.attributes.electricity.supply_postcode);
form.setFieldValue("elec_current_supplier",findUser.attributes.electricity.current_supplier);
form.setFieldValue("elec_supply_number",findUser.attributes.electricity.supply_number);
form.setFieldValue("elec_billing_name",findUser.attributes.electricity.billing_name);
//form.setFieldValue("elec_contract_end_date",findUser.attributes.electricity.contract_end_date);
form.setFieldValue("elec_billing_amount",findUser.attributes.electricity.billing_amount);
form.setFieldValue("elec_standing_charge",findUser.attributes.electricity.standing_charge);
form.setFieldValue("elec_night_rate",findUser.attributes.electricity.night_rate);
form.setFieldValue("elec_capacity_charge",findUser.attributes.electricity.capacity_charge);
form.setFieldValue("elec_account_number",findUser.attributes.electricity.account_number);
form.setFieldValue("elec_msn",findUser.attributes.electricity.msn);
form.setFieldValue("elec_eac",findUser.attributes.electricity.eac);
form.setFieldValue("elec_metertype",findUser.attributes.electricity.metertype);
form.setFieldValue("elec_unit_rate",findUser.attributes.electricity.unit_rate);
form.setFieldValue("elec_eve_weekend",findUser.attributes.electricity.eve_weekend);
form.setFieldValue("elec_fit_charge",findUser.attributes.electricity.fit_charge);


form.setFieldValue("elec_billing_name",findUser.attributes.electricity.billing_name);
form.setFieldValue("elec_supply_address",findUser.attributes.electricity.supply_address);
form.setFieldValue("elec_supply_postcode",findUser.attributes.electricity.supply_postcode);
form.setFieldValue("elec_current_supplier",findUser.relations.supplier.electricity.name);
form.setFieldValue("elec_supply_number",findUser.attributes.electricity.supply_number);
form.setFieldValue("elec_billing_name",findUser.attributes.electricity.billing_name);
//form.setFieldValue("elec_contract_end_date",findUser.attributes.electricity.contract_end_date);
form.setFieldValue("elec_billing_amount",findUser.attributes.electricity.billing_amount);
form.setFieldValue("elec_standing_charge",findUser.attributes.electricity.standing_charge);
form.setFieldValue("elec_night_rate",findUser.attributes.electricity.night_rate);
form.setFieldValue("elec_capacity_charge",findUser.attributes.electricity.capacity_charge);
form.setFieldValue("elec_account_number",findUser.attributes.electricity.account_number);
form.setFieldValue("elec_msn",findUser.attributes.electricity.msn);
form.setFieldValue("elec_eac",findUser.attributes.electricity.eac);
form.setFieldValue("elec_metertype",findUser.relations.meter_type.electricity.name);
form.setFieldValue("elec_unit_rate",findUser.attributes.electricity.unit_rate);
form.setFieldValue("elec_eve_weekend",findUser.attributes.electricity.eve_weekend);
form.setFieldValue("elec_fit_charge",findUser.attributes.electricity.fit_charge);

// if ([2,5,6,7,8].includes(findUser.attributes.lead_status_list_id)) {
//   // Set the form field value
//   form.setFieldValue("lead_status_list_id", findUser.attributes.lead_status_list_id);
// }

form.setFieldValue("gas_billing_name",findUser.attributes.gas.billing_name);
form.setFieldValue("gas_supply_address",findUser.attributes.gas.supply_address);
form.setFieldValue("gas_supply_postcode",findUser.attributes.gas.supply_postcode);
form.setFieldValue("gas_current_supplier",findUser.relations.supplier.gas.name);
form.setFieldValue("gas_mpr",findUser.attributes.gas.mpr);
form.setFieldValue("gas_billing_name",findUser.attributes.gas.billing_name);
//form.setFieldValue("gas_contract_end_date",findUser.attributes.gas.contract_end_date);
form.setFieldValue("gas_billing_amount",findUser.attributes.gas.billing_amount);
form.setFieldValue("gas_standing_charge",findUser.attributes.gas.standing_charge);
form.setFieldValue("gas_account_number",findUser.attributes.gas.account_number);
form.setFieldValue("gas_msn",findUser.attributes.gas.msn);
form.setFieldValue("gas_eac",findUser.attributes.gas.eac);
form.setFieldValue("gas_metertype",findUser.relations.meter_type.gas.name);
form.setFieldValue("gas_unit_rate",findUser.attributes.gas.unit_rate);

}

  

  const loadMasterData = async () => {
     const response =await masterSource();
     const meterOpt = [];
     const productsSupplier = [];
     response.data.products.map(item=> productsSupplier.push({label: item.product_name,value: item.id}))
     response.data.meter_types.map(item=>  meterOpt.push({label: item.meter_type,value: item.id}))
     setMeterTypeOption(meterOpt);
     setProductSupplierOptions(productsSupplier);
     
  }
  useEffect(()=>{

    loadMasterData();
    if(isEdit === true){
     
      setInitialValues(findUser);
    }else{
     
       //do nothing
    }
    
  
    },[]);
  function SurveyLeadUpdate(requestBody){
    
    const id = findUser.id;
    const requestBodyFinal = {...requestBody,
      gas_current_supplier:findUser.attributes.gas.current_supplier,
      gas_metertype:findUser.attributes.gas.metertype,
      product_id:2

    }
    
    
    const LEAD_UPDATE_URL = `${LIVE_BASE}/leads/`+id;
    axios.put(LEAD_UPDATE_URL,requestBodyFinal).then((res) => {
      notification.success({message:"Successfully updated the agent details !"});
      form.resetFields();
    
    
  }).catch((error) => {
    
  });
  
  } 
  const handleDropdownChange = (e) => {
    setdropdownValue(items.key);
  };

  const onChangeCheckBox = (e) => {
    
  };
  const onFinish = (values) => {
    
    const callback_dateValue = moment(values.callback_date).format("DD-MM-YYYY");
    const gas_contract_end_dateValue = moment(values.gas_contract_end_date).format("DD-MM-YYYY");
    const elec_contract_end_dateValue = moment(values.elec_contract_end_date).format("DD-MM-YYYY");
  
   
  const request = values;
  const  finalRequest ={
    ...values,
    callback_date: callback_dateValue,
    gas_contract_end_date: gas_contract_end_dateValue,
    elec_contract_end_date:  elec_contract_end_dateValue,
    product_id: product_id
  }

  
  
  //loadData(e);

if(isEdit === true){
  const request = values;

  const  finalRequestUpdate ={
    ...values,
    callback_date: callback_dateValue,
    gas_contract_end_date: gas_contract_end_dateValue,
    elec_contract_end_date:  elec_contract_end_dateValue,
    

  }
  SurveyLeadUpdate(finalRequestUpdate);
}else{
  surveyLeadSave(finalRequest).then((res) => {
    notification.success({message:"Successfully added !"});
    form.resetFields();
  
  
}).catch((error) => {
  
});
}
 
     // if(supplyDeatils === "electricity" ){
    //   const val1 = ref1.current?.handleValidation();
    //   );
    // }else{
    //   const val2 = ref2.current?.handleValidation();
    //   );
    // }
  };
  const [evalue, setEvalue] = useState('');
  const [gvalue, setGvalue] = useState('');
  const [value, setValue] = useState('');

  const handleNewChange = (e) => {
    setValue(e.target.value);
  };

  const handleElecMetreType = (e) => {
    setEvalue(e.target.value);
  };

  const handleGasMetreType = (e) => {
    setGvalue(e.target.value);
  };

  
  const meterTypeElectricity =[
    {
      product_id:'1',
      label: 'Economy'
    },
    {
      product_id:'1',
      label: 'Standard'
    }]
  const items = [
    {
      label: 'Call Back',
      key: '1',
    },
    {
      label: 'Plain Servey',
      key: '2',
    },
    {
      label: 'Quality',
      key: '3',
    },
    {
      label: 'Quality Low Eac',
      key: '4',
    },
  ];

 
  const [product_id, setProduct_id] = useState('');
  const handleOnChange1 = (event) => {
    //const value = event.target.value;
    setProduct_id(event);
    
    //form.setFieldValue('product_id',1);
  //  
  }
const handleOnChange = (event) => {
  
  setProduct_id(event);
  
  //form.setFieldValue('product_id',1);
  
}
const [inputValue, setInputValue] = useState("inputValue");
  const handleInput = (input) => {
    const capsValue = input.target.value.toUpperCase();
    setInputValue(capsValue);
  }

// const divDisplay = ()=>{
//     let result;
//     supplyDeatils === "electricity" 
//     ? (result = <ElectricityComponent ref={ref1}  />)
//      : (result = <GasComponent  ref={ref2} />);
//     return result;
// }


 

const handleChildValidation = (values)=>{
 const val1 = ref1.current?.handleValidation();
 const val2 = ref2.current?.handleValidation();
 
}
const formItemLayout = {
  labelCol: { xs: { span: 24 }, sm: { span: 30 }, md: { span: 8 }, lg: { span: 8 } },
  wrapperCol: { xs: { span: 35 }, sm: { span: 20 }, md: { span: 50 }, lg: { span: 50 } }

};
// const tailFormItemLayout = {
//   wrapperCol: { xs: { span: 24 }, sm: { span: 12, offset: 12 }, md: { span: 12, offset: 8 }, lg: { span: 12, offset: 8 } }
// };
  return (
    <><Form
      name="register"
      onFinish={onFinish}
      form={form}      
      initialValues={{
        
        ...initialFormValues
      }}
      {...formItemLayout}
     

      style={{
        maxWidth: 800,
      }} 
      scrollToFirstError
    >
      <Space>{" "}</Space>
      {/* <Form.Item
        name="agentName"
        label="Agent Name"
       
      >
      <label><p>{form.setFieldValue("Shakir")}</p> </label>
      
      </Form.Item> */}
            <Divider variant="dotted" style={{ borderColor: '#7cb305',marginLeft:'20%' }}>Lead Details</Divider>
            <Flex  style={{marginTop:'40px'}}>
        <Form.Item 
        name="agent_name"
        label="Agent Name"
        style={{ marginLeft:'22%', textAlign: "center" }}
      >
        
       <Input style={{borderColor:'forestgreen',fontStretch:'expanded'}}
       placeholder={user.name} readOnly />
        </Form.Item>
      <Form.Item 
      style={{marginLeft:'27%'}}
        name="agent_id"
        label="Lead ID"
        >
        <InputNumber  style={{borderColor:'forestgreen',fontStretch:'expanded'}}/>
        </Form.Item>
        </Flex>
      
      <Form.Item
        name="customer_name"
        label="Customer Name"
        rules={[
          {
            required: true,
            message: 'Please input your Customer Name!',
          },
        ]}
      >
        <Input 
        style={{borderColor:'forestgreen',fontStretch:'expanded'}}
        onInput={e => e.target.value = e.target.value.toUpperCase()}/>
        </Form.Item>
        <Form.Item
        name="billing_address"
        label="Billing Address"
        rules={[
          {
            required: true,
            message: 'Please input your Billing Address!',
          },
        ]}
      >
        <Input 
        style={{borderColor:'forestgreen',fontStretch:'expanded'}}
        onInput={e => e.target.value = e.target.value.toUpperCase()}/>
        </Form.Item>
        <Flex style={{ marginLeft:'14%' }}>
        <Form.Item
        name="billing_postcode"
        label="Billing Postcode"
        style={{ marginLeft:'30px', textAlign: "center",textOverflow:false }}
        rules={[
          {
            required: true,
            message: 'Please input your Billing Postcode!',
          },
        ]}
      >
        <Input 
        maxLength={8}
        pattern="[A-Za-z0-9]{8}"
        title="Please enter 8 digits alphanumeric only."
        style={{marginLeft:'18px',borderColor:'forestgreen',fontStretch:'expanded'}}onInput={e => e.target.value = e.target.value.toUpperCase()}/>
      </Form.Item>

      <Form.Item
        name="contact_number"
        label="Contact Number"
        
        rules={[
          {
            required: true,
            message: 'Please input your contact number!',
          },
         

        ]}
        
      >
         <Input maxLength={10}/>
      </Form.Item></Flex>
      <Form.Item
        name="email_address"
        label="Email Address"
        rules={[
          {
            type: 'email',
            message: 'The input is not valid Email Address!',
          },
          {
            required: true,
            message: 'Please input your Email Address',
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Checkbox onChange={onChangeCheckBox}>Sames as above</Checkbox>
      <Form.Item
        name="product_id"
        label="Supply Details"
        // rules={[
        //   {
        //     message: 'Please select Supply Details!',
        //   },
        // ]}
      >
 
    { 
      <Select 
      defaultValue="Gas"
      style={{ width: 120 }}  onChange={handleOnChange1}
    options = {productSupplierOptions}/> }
    {/* {
       products.map(product => (
        <Select.Option value={product.key}>{product.label}</Select.Option>
       ))} */}
     {/* <Select.Option value="1">Gas</Select.Option> 
    <Select.Option value="2">Electricity</Select.Option> 

     </Select> */}
      {/* {   
            <select placeholder="Select Options" onChange={handleOnChange}>
            <option value ="1">Gas</option>
            <option value ="2">Electricity</option>
            </select>
          
      
          } */}
        <div className='dropdown-menu'>
        <Space>{" "}</Space>
        {
        product_id === 1
    ? (<>  <Form.Item 
      name="elec_billing_name"
      label="Billing Name"
      rules={[
        {
          required: true,
          message: 'Please input your Billing Name',
        },
      ]}
    >
      <Input onInput={e => e.target.value = e.target.value.toUpperCase()}/>
    </Form.Item>

    <Form.Item
      name="elec_supply_address"
      label="Supply Address"
      rules={[
        {
          required: true,
          message: 'Please input your Supply Address!',
        },
      ]}
    >
      <Input onInput={e => e.target.value = e.target.value.toUpperCase()}/>
      </Form.Item>
      <Form.Item
      name="elec_supply_postcode"
      label="Supply Postcode"
      rules={[
        {
          required: true,
          message: 'Please input your Supply Postcode!',
          toUpperCase : true,
        },
      ]}
    >
      <Input onInput={e => e.target.value = e.target.value.toUpperCase()}/>
      </Form.Item>
      <div>
      <div className="side-by-side">
      <Form.Item
      name="elec_current_supplier"
      label="Current Supplier"
      
      rules={[
        {
          required: true,
          message: 'Please input your Current Supplier!',
        },
      ]}
    >
    <Select placeholder="Select Supplier" style={{ width: 120 }} options = {[
    {
      label: 'British Gas',
      value: '1',
    },
    {

      label: 'EON Next',
      value: '2',
    }
  ]}/>
    </Form.Item>
    <Space>{" "}</Space>
    <Form.Item
      name="elec_account_number"
      label="Account Number"
      // rules={[
      //   {
      //     required: true,
      //     message: 'Please input your account number!',
      //   },
      // ]}   
    >
       <Input />
    </Form.Item>
    </div></div>
    <div>
      <div className="side-by-side">
      <Form.Item
      name="elec_supply_number"
      label="Supply Number"
      rules={[
        {
          required: true,
          message: 'Please input your Supply Number!',
        },
      ]}
    >
      <Input/>
    </Form.Item>

    <Form.Item
      name="elec_msn"
      label="MSN"
      rules={[
        {
          message: 'Please input your MSN!',
          toUpperCase : true,
        },
      ]}
      
    >
       <Input onInput={e => e.target.value = e.target.value.toUpperCase()}/>
    </Form.Item>
    </div></div>
    <div>
      <div className="side-by-side">
      <Form.Item
      name="elec_contract_end_date"
      label="Contract End Date"
      rules={[
        {
          message: 'Please input your Contract End Date!',
          required: true,
        },
      ]}
      //getValueProps={(i)=> ({value:moment(i)})}
    >
     <DatePicker
    dateFormat="YYYY-MM-DD"
    // value={Elec_contract_end_date}
    // onChange={(date) => {
    //   const d = new Date(date).toLocaleDateString('fr-FR');
    //   
    //   setDateECED(d);
    // }}
  />
    </Form.Item>

    <Form.Item
      name="elec_eac"
      label="EAC (kWh Annually)"
      rules={[
        {
          message: 'Please input your EAC!',
        },
        () => ({
          validator(_, value) {
            if (!value) {
              return Promise.reject();
            }
            if (isNaN(value)) {
              return Promise.reject("EAC has to be a number.");
            }
            return Promise.resolve();
          },
        }),
      ]}
      
    >
       <Input  />
    </Form.Item>
    </div></div>
    <div>
      <div className="side-by-side">
      <Form.Item
      name="elec_billing_amount"
      label="Billing Amount"
      rules={[
        {
         // required: true,
         // message: 'Please input your Billing Amount!',
          toUpperCase: true,
        },
      ]}
    >
      <Input onInput={e => e.target.value = e.target.value.toUpperCase()}/>
    </Form.Item>

    <Form.Item
      name="elec_metertype"
      label="Meter Type" onChange={handleElecMetreType}
    >
      <Select placeholder="Select Options" style={{ width: 120 }}  options = {[
    {
      label: 'Economy',
      value: '1',
    },
    {

      label: 'Standard',
      value: '2',
    }
  ]}/></Form.Item>
    </div></div>
    <div>
      <div className="side-by-side">
      <Form.Item
      name="elec_standing_charge"
      label="Standing Charge"
      rules={[
        {
          message: 'Please input your Standing Charge!',
        },
        () => ({
          validator(_, value) {
            if (!value) {
              return Promise.reject();
            }
            if (isNaN(value)) {
              return Promise.reject("Standing Charge has to be a number.");
            }
            return Promise.resolve();
          },
        }),
      ]}
    >
      <Input/>
    </Form.Item>

    <Form.Item
      name="elec_unit_rate"
      label="Unit Rate"
      rules={[
        {
          message: 'Please input your Unit Rate!',
        },
        () => ({
          validator(_, value) {
            if (!value) {
              return Promise.reject();
            }
            if (isNaN(value)) {
              return Promise.reject("Unit Rate has to be a number.");
            }
            return Promise.resolve();
          },
        }),
      ]}
      
    >
       <Input />
    </Form.Item>
    </div></div>
    <div>
      <div className="side-by-side">
      <Form.Item
      name="elec_night_rate"
      label="Night Rate"
      rules={[
        {
          message: 'Please input your Night Rate!',
        },
        () => ({
          validator(_, value) {
            if (!value) {
              return Promise.reject();
            }
            if (isNaN(value)) {
              return Promise.reject("Night Rate has to be a number.");
            }
            return Promise.resolve();
          },
        }),
      ]}
    >
      <Input/>
    </Form.Item>

    <Form.Item
      name="elec_eve_weekend"
      label="Eve Weekend"
      rules={[
        {
          message: 'Please input your Eve Weekend!',
        },
        () => ({
          validator(_, value) {
            if (!value) {
              return Promise.reject();
            }
            if (isNaN(value)) {
              return Promise.reject("Eve Weekend has to be a number.");
            }
            return Promise.resolve();
          },
        }),
      ]}
      
    >
       <Input />
    </Form.Item>
    </div></div>
    <div>
      <div className="side-by-side">
      <Form.Item
      name="elec_capacity_charge"
      label="Capacity Charge"
      rules={[
        {
          message: 'Please input your Capacity Charge!',
        },
        () => ({
          validator(_, value) {
            if (!value) {
              return Promise.reject();
            }
            if (isNaN(value)) {
              return Promise.reject("Capacity Charge has to be a number.");
            }
            return Promise.resolve();
          },
        }),
      ]}
    >
      <Input/>
    </Form.Item>

    <Form.Item
      name="elec_fit_charge"
      label="FIT Charge"
      rules={[
        {
          message: 'Please input your FIT Charge!',
        },
        () => ({
          validator(_, value) {
            if (!value) {
              return Promise.reject();
            }
            if (isNaN(value)) {
              return Promise.reject("FIT charge has to be a number.");
            }
            return Promise.resolve();
          },
        }),
      ]}
      
    >
       <Input />
    </Form.Item>
    </div></div>
    </>
   )
     : (<> <Form.Item
      name="gas_billing_name"
      label="Billing Name"
      rules={[
        {
          required: true,
          message: 'Please input your Billing Name',
        },
      ]}
    >
      <Input onInput={e => e.target.value = e.target.value.toUpperCase()}/>
    </Form.Item>

    <Form.Item
      name="gas_supply_address"
      label="Supply Address"
      rules={[
        {
          required: true,
          message: 'Please input your Supply Address!',
        },
      ]}
    >
      <Input onInput={e => e.target.value = e.target.value.toUpperCase()}/>
      </Form.Item>
      <Form.Item
      name="gas_supply_postcode"
      label="Supply Postcode"
      rules={[
        {
          required: true,
          message: 'Please input your Supply Postcode!',
        },
      ]}
    >
      <Input onInput={e => e.target.value = e.target.value.toUpperCase()}/>
      </Form.Item>
      <div>
      <div className="side-by-side">
      <Form.Item
      name="gas_current_supplier"
      label="Current Supplier"
      rules={[
        {
          required: true,
          message: 'Please input your Current Supplier!',
        },
      ]}
    >
    <Select placeholder="Select Supplier"  options = {[
    {
      label: 'British Gas',
      value: '3',
    },
    {

      label: 'EON Next',
      value: '4',
    }
  ]}/>
    </Form.Item>

    <Form.Item
      name="gas_account_number"
      label="Account Number"
      rules={[
        {
          message: 'Please input your account number!',
        },
      ]}
      
    >
       <Input />
    </Form.Item>
    </div></div>
    <div>
      <div className="side-by-side">
      <Form.Item
      name="gas_mpr"
      label="MPR"
      rules={[
        {
          required: true,
          message: 'Please input your MPR!',
          maxLength: 10,
        },
        () => ({
          validator(_, value) {
            if (!value) {
              return Promise.reject();
            }
            if (isNaN(value)) {
              return Promise.reject("MPR has to be a number.");
            }
            return Promise.resolve();
          },
        }),
      ]}
    >
      <Input/>
    </Form.Item>

    <Form.Item
      name="gas_msn"
      label="MSN"
      rules={[
        {
          message: 'Please input your MSN!',
        },
      ]}
      
    >
       <Input onInput={e => e.target.value = e.target.value.toUpperCase()}/>
    </Form.Item>
    </div></div>
    <div>
      <div className="side-by-side">
      <Form.Item
      name="gas_contract_end_date"
      label="Contract End Date"
      rules={[
        {
          message: 'Please input your Contract End Date!',
          required: true
        },
      ]}
      //getValueProps={(i)=> ({value:moment(i)})}
    >
       <DatePicker
    // dateFormat="YYYY-MM-DD"
    // value={Gas_contract_end_date}
    // onChange={(date) => {
    //   const d = new Date(date).toLocaleDateString('fr-FR');
    //   
    //   setDateGCED(d);
    // }}
      
  />
    </Form.Item>

    <Form.Item
      name="gas_eac"
      label="EAC (kWh Annually)"
      rules={[
        {
          required: true,
          message: 'Please input your EAC!',
        },
        () => ({
          validator(_, value) {
            if (!value) {
              return Promise.reject();
            }
            if (isNaN(value)) {
              return Promise.reject("MPR has to be a number.");
            }
            return Promise.resolve();
          },
        }),
      ]}
      
    >
       <Input />
    </Form.Item>
    </div></div>
    <div>
      <div className="side-by-side">
      <Form.Item
      name="gas_billing_amount"
      label="Billing Amount"
      // rules={[
      //   {
      //     message: 'Please input your Billing Amount!',
      //   },
      // ]}
    >
      <Input/>
    </Form.Item>

    <Form.Item
      name="gas_metertype"
      label="Meter Type"
      // rules={[
      //   {
      //     message: 'Please input your Meter Type!',
      //   },
      // ]}
      
    >
     
     <Select placeholder="Select Options" style={{ width: 120 }}  options = {[
    {
      label: 'Gas',
      value: '3',
    }
  ]}/>

    </Form.Item>
    </div></div>
    <div>
      <div className="side-by-side">
      <Form.Item
      name="gas_standing_charge"
      label="Standing Charge"
      rules={[
        // {
        //   message: 'Please input your Standing Charge!',
        // },
        () => ({
          validator(_, value) {
            if (!value) {
              return Promise.reject();
            }
            if (isNaN(value)) {
              return Promise.reject("Standing Charge has to be a number.");
            }
            return Promise.resolve();
          },
        }),
      ]}
    >
      <Input/>
    </Form.Item>

    <Form.Item
      name="gas_unit_rate"
      label="Unit Rate"
      rules={[
        // {
        //   message: 'Please input your Unit Rate!',
        // },
        () => ({
          validator(_, value) {
            if (!value) {
              return Promise.reject();
            }
            if (isNaN(value)) {
              return Promise.reject("Unit Rate has to be a number.");
            }
            return Promise.resolve();
          },
        }),
      ]}
      
    >
       <Input />
    </Form.Item>
    </div></div>
    </>)
}
        </div>
      </Form.Item>

     
      <Form.Item
        name="survey_feedback"
        label="Agent Feedback"
        rules={[
          {
            required: true,
            message: 'Please input Agent Feedback',
          },
        ]}
      >
        <Input.TextArea />
      </Form.Item>

      <Form.Item
        name="quality_feedback"
        label="Quality Feedback"
        rules={[
          {
            required: true,
            message: 'Please input Quality Feedback',
          },
        ]}
      >
        <Input.TextArea  />
      </Form.Item>

      <Form.Item
        name="callback_date"
        label="Call Back Date"
        rules={[
          {
            type:"object",
            message: 'Please input your Call Back Date',
            required: true,
          },
        ]}
        //getValueProps={(i)=> ({value:moment(i)})}
      >
         <DatePicker
  
  />
  {/* <Input/> */}
      </Form.Item>
      <div className="side-by-side" style={{marginLeft: '400px'}}>
      <Form.Item  name="lead_status_list_id"
      style={{marginRight:'10px'}}
      onChange={handleNewChange}>
      <Select placeholder="Select Options" style={{ marginLeft:'100px',width: '280px' }} 
      options = { salesOptionsListDropdown}/></Form.Item>
      
    
      <Form.Item>
    <Button type="primary" htmlType="submit" >Submit</Button>
        
      </Form.Item>
      </div>
    </Form></>
  );
};
export default RegistrationFormAdmin;